import {useRef, useEffect } from 'react';

export function useDebounce(callback, value, delay) {
    const debounceRef=useRef();
    
    useEffect(() => {
        if(debounceRef.current){
            clearTimeout(debounceRef.current);
        }
        debounceRef.current=setTimeout(()=>{
            callback();
        },delay)
        return () => {
            clearTimeout(debounceRef.current);
        };
    }, [value, delay]);
}
